"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeftPaneHeaderComponent = void 0;
var React = require("react");
var Localize_1 = require("../../gen-src/Localize");
var RootReducer_1 = require("../app/RootReducer");
var PredictiveModelSlice_1 = require("../store/slice/PredictiveModelSlice");
var styles = require("../styles/LayoutStyles");
var TestIds_1 = require("../util/TestIds");
var LeftPaneHeaderComponent = function () {
    var model = (0, RootReducer_1.useAppSelector)(PredictiveModelSlice_1.selectModel);
    var modelName = model.name;
    var modelVersion = model.activeVersion.versionNumber;
    var renderModelName = function () {
        if (!modelName) {
            return null;
        }
        return React.createElement("h1", { className: styles.modelResultMetadataHeader }, modelName);
    };
    var renderModelVersion = function () {
        if (!modelVersion) {
            return null;
        }
        return (React.createElement("div", { className: styles.predictiveModelVersionStyle, "data-tb-test-id": TestIds_1.MODEL_VERSION_TEST_ID }, Localize_1.Messages.modelVersion({ version: modelVersion })));
    };
    return (React.createElement(React.Fragment, null,
        renderModelName(),
        renderModelVersion()));
};
exports.LeftPaneHeaderComponent = LeftPaneHeaderComponent;
//# sourceMappingURL=LeftPaneHeaderComponent.js.map